module.exports = "https://img1.huilianyi.com/6/corp-request@3x.65b9411d0a.appcore.png";